// Type guards ----------------------------------------------------------------
export const isAlloyBusinessEntity = (entity) => {
    return 'entityType' in entity && entity.entityType === 'business';
};
export const isAlloyPersonEntity = (entity) => {
    return 'entityType' in entity && entity.entityType === 'person';
};
